import { Period } from '@portal-shared/app/entities/period.model';
import { GuidString } from '@portal-shared/app/typings/guid-string.type';
import { UuidUtils } from '@portal-shared/app/utils/uuid.utils';
import { AssignmentPeriodDto } from '@services/dtos/assignment-period.dto';
import { AssignmentDto } from '@services/dtos/assignment.dto';
export class AssignmentPeriod {
  private static readonly newPrefix = 'new_';
  public id: GuidString;
  public plannedHours?: number;
  public realHours?: number;

  public constructor(
    dto: AssignmentPeriodDto,
    public assignment: AssignmentDto,
    public period: Period
  ) {
    this.id = dto.id;
    this.plannedHours = dto.plannedHours;
    this.realHours = dto.realHours;
  }

  public isEquivalentTo(assignmentPeriod: AssignmentPeriod) {
    const equivByProperties =
      this.assignment.id === assignmentPeriod.assignment.id && this.period.id === assignmentPeriod.period.id;
    const equivById = this.id === assignmentPeriod.id;
    return equivByProperties || equivById;
  }

  public toDto(): AssignmentPeriodDto {
    return {
      assignmentId: this.assignment.id,
      periodId: this.period.id,
      plannedHours: this.plannedHours,
      realHours: this.realHours,
      id: this.id
    };
  }

  public isNewAssignmentPeriod() {
    return AssignmentPeriod.isNewAssignmentPeriodId(this.id);
  }

  public static isNewAssignmentPeriod(assignmentPeriodDto: AssignmentPeriodDto) {
    return this.isNewAssignmentPeriodId(assignmentPeriodDto.id);
  }

  public static isNewAssignmentPeriodId(assignmentId: GuidString) {
    return assignmentId.startsWith(AssignmentPeriod.newPrefix);
  }

  public static newAssignmentPeriodDtoFactory(
    assignmentId: string,
    periodId: number,
    plannedHours: number | undefined
  ): AssignmentPeriodDto {
    return {
      assignmentId,
      periodId,
      plannedHours,
      id: this.newPrefix + UuidUtils.generateUuid()
    };
  }
}
